import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shieldCheckFilled"
const ShieldCheckFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5S16.5 4.5 21 6C21 21 12 22.5 12 22.5S11.825 22.47 11.524 22.38C11.015 22.225 10.146 21.896 9.152 21.233Q8.957 21.104 8.755 20.956 8.625 20.86 8.491 20.755 8.267 20.579 8.038 20.378C7.148 19.598 6.23 18.538 5.424 17.106Q5.12 16.57 4.842 15.958 4.652 15.54 4.477 15.088 4.248 14.5 4.048 13.85 3.758 12.913 3.54 11.84 3.446 11.377 3.368 10.889C3.134 9.446 3 7.823 3 6 4.24 5.646 5.395 5.207 6.437 4.745Q7.257 4.38 7.977 4.008 8.414 3.784 8.809 3.565 9.037 3.437 9.25 3.313 9.48 3.18 9.693 3.052 10.047 2.839 10.353 2.645L10.682 2.43C11.527 1.877 12 1.5 12 1.5M10.875 13.565 8.78 11.47 7.72 12.53 10.875 15.686 15.97 10.59C16.555 10.005 16.555 9.055 15.97 8.47z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ShieldCheckFilledIcon
